<template>
  <quick-preview :is-preview="show" @input="closePreview" :show-close-btn="true">
    <template v-slot:content-en>
      <preview-content
        lang="en" 
        :profile="profile"
        :name="enContentObject.name"
        :description="enContentObject.description"
        :departments="enDepartments"
        :specialties="enSpecialties"
        :languages="languages"
        :schedules="schedules"
        :department-options="enDepartmentOptions"
        :selected-dept-id="selectedDeptId"
        :content-repeaters="enContentRepeaters"
        @change-department="handleChangeDepartment"
      />
    </template>
    <template v-slot:content-th>
      <preview-content
        lang="th"
        :profile="profile"
        :name="thContentObject.name"
        :description="thContentObject.description"
        :departments="thDepartments"
        :specialties="thSpecialties"
        :languages="languages"
        :schedules="schedules"
        :department-options="thDepartmentOptions"
        :selected-dept-id="selectedDeptId"
        :content-repeaters="thContentRepeaters"
        @change-department="handleChangeDepartment"
      />
    </template>
  </quick-preview>
</template>
<script>
import QuickPreview from '@/components/QuickPreview'
import PreviewContent from '@/components/doctor/PreviewContent'
import {mapState, mapActions} from 'vuex'

export default {
  name: 'Preview',
  components: {
    QuickPreview,
    PreviewContent
  },
  props: {
    show: {type: Boolean, required: true},
    closePreview: {type: Function},
    doctorObject: {type: Object},
    departmentListTh: {type: Array},
    departmentListEn: {type: Array}
  },
  data() {
    return {
      activeTab: 'th',
      selectedDeptId: null
    }
  },
  computed: {
    ...mapState('doctor', [
      'departmentList',
      'languageList',
      'schedules'
    ]),
    ...mapState('doctorContentRepeater', [
      'contentRepeaterList'
    ]),
    profile() {
      return this.doctorObject.profile
    },
    enContentObject() {
      return this.doctorObject.contents.find(obj => obj.code === 'en') || {}
    },
    thContentObject() {
      return this.doctorObject.contents.find(obj => obj.code === 'th') || {}
    },
    thDepartments() {
      return this.departmentListTh.map(d => d.name)
    },
    enDepartments() {
      return this.departmentListEn.map(d => d.name)
    },
    thSpecialties() {
      return this.doctorObject.specialty_th_tags.map(t => t.value)
    },
    enSpecialties() {
      return this.doctorObject.specialty_en_tags.map(t => t.value)
    },
    languages() {
      return this.doctorObject.languages.map(l => l.name)
    },
    thDepartmentOptions() {
      return this.departmentListTh.map(d => {
        return {
          text: d ? d.name : '',
          value: d ? (d.department_id || d.id) : null
        }
      }).filter(o => o.text !== '' && o.value !== null)
    },
    enDepartmentOptions() {
      return this.departmentListEn.map(d => {
        return {
          text: d ? d.name : '',
          value: d ? (d.department_id || d.id) : null
        }
      }).filter(o => o.text !== '' && o.value !== null)
    },
    thContentRepeaters() {
      return this.contentRepeaterList.map(item => {
        const content = item.contents.find(c => c.code === 'th') || {}
        return {
          id: item.id,
          title: content.title,
          description: content.description
        }
      })
    },
    enContentRepeaters() {
      return this.contentRepeaterList.map(item => {
        const content = item.contents.find(c => c.code === 'en') || {}
        return {
          id: item.id,
          title: content.title,
          description: content.description
        }
      })
    }
  },
  watch: {
    doctorObject: {
      handler(newDoctor) {
        if (newDoctor) {
          const id = newDoctor.id
          const deptList = this.departmentListTh || []
          if (deptList.length > 0) {
            const firstDept = deptList[0]
            const firstDeptId = firstDept.id
            this.selectedDeptId = firstDeptId
            this.handleFetchSchedules(id, firstDeptId)
          }
          if (id) {
            this.getContentRepeaters(id)
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions('doctor', ['setSchedules']),
    ...mapActions('doctorContentRepeater', ['getContentRepeaters']),
    async handleFetchSchedules(id, departmentId) {
      const validId = id || (this.doctorObject ? this.doctorObject.id : null)
      if (validId && (departmentId !== null && departmentId !== undefined)) {
        await this.setSchedules({id: validId, departmentId: departmentId})
      }
    },
    handleChangeDepartment(deptId) {
      this.selectedDeptId = deptId
      const id = this.doctorObject ? this.doctorObject.id : null
      this.handleFetchSchedules(id, deptId)
    },
    close() {
      this.closePreview()
    }
  }
}
</script>

